export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        members: action.members,
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
